import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { filter, of, switchMap } from "rxjs";

import RouteNameConstants from "../constants/route-name-constants";
import { AuthService } from "./../services/auth.service";

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
  ) {}

  canActivate(route, state: RouterStateSnapshot) {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      switchMap(() => {
        if (this.authService.isLoggedIn) {
          return of(true);
        }

        this.router.navigate([RouteNameConstants.LOGIN], {
          queryParams: { returnUrl: state.url },
        });
        return of(false);
      }),
    );
  }
}
